import { useQuery } from '@tanstack/react-query';
import { AI_API } from 'utils/globalApiServices';
import Organization from 'infrastructure/Organization';
import { useRealplayStore } from 'features/realplays/RealPlays.store';
import RealPlayRecordDataHelper from 'features/realplays/RealPlayRecordData.helper';

const queryFn = async ({ assignment_uuid, scenario_uuid, response_uuid }) => {
  const org_id = Organization.getSelectedOrg()?.id;
  const url = `orgs/${org_id}/realplays/assignments/${assignment_uuid}/scenarios/${scenario_uuid}/responses/${response_uuid}/rating/`;
  const { data } = await AI_API.get(url);
  return data || [];
};

const useGetAssignmentScenarioResponseRatingQuery = ({
  assignment_uuid,
  scenario_uuid,
  response_uuid,
  enabled,
}) => {
  const { setRealPlayReviewToQualified } = useRealplayStore();
  const { ratingCriteria } = RealPlayRecordDataHelper();
  return useQuery({
    queryFn: () => queryFn({ assignment_uuid, scenario_uuid, response_uuid }),
    queryKey: [
      'ASSIGNMENT_SCENARIO_RESPONSE_RATING',
      assignment_uuid,
      scenario_uuid,
      response_uuid,
    ],
    enabled,
    onSuccess: (response) => {
      const realPlayReviewToQualified = {
        created_at: response?.created_at,
        updated_at: response?.updated_at,
        feedback: response?.feedback,
        status: response?.status,
        rating_criteria:
          response?.rating_criteria ??
          ratingCriteria?.map((r) => ({
            uuid: r?.uuid,
            name: r?.name,
            rating: 0,
            reasoning: null,
            improvement_suggestion: null,
          })),
        summary: response?.summary,
        final_decision: response?.final_decision,
        uuid: response?.uuid,
        isEditing: false,
        feedbackTemp: response?.feedback,
        rating_criteria_temp:
          response?.rating_criteria ??
          ratingCriteria?.map((r) => ({
            uuid: r?.uuid,
            name: r?.name,
            rating: 0,
            reasoning: null,
            improvement_suggestion: null,
          })),
      };
      setRealPlayReviewToQualified(realPlayReviewToQualified);
    },
    onError: () => {
      const realPlayReviewToQualified = {
        created_at: '',
        updated_at: '',
        feedback: null,
        status: 'FAILED',
        rating_criteria: ratingCriteria?.map((r) => ({
          uuid: r?.uuid,
          name: r?.name,
          rating: 0,
          reasoning: null,
          improvement_suggestion: null,
        })),
        summary: null,
        final_decision: null,
        uuid: assignment_uuid,
        isEditing: false,
        feedbackTemp: null,
        rating_criteria_temp: ratingCriteria?.map((r) => ({
          uuid: r?.uuid,
          name: r?.name,
          rating: 0,
          reasoning: null,
          improvement_suggestion: null,
        })),
      };
      setRealPlayReviewToQualified(realPlayReviewToQualified);
    },
  });
};

export default useGetAssignmentScenarioResponseRatingQuery;
